import SlotsHistoryItem from './SlotsHistoryItem';
export default SlotsHistoryItem;